export default {"src":"/_next/static/media/Robotic-Assisted-Precision.97096687.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};